// Add your custom JS here.

// Fade page transition
// document.addEventListener('DOMContentLoaded', function() {
//     fadeIn(document.body, 500); // Adjust 500 to change fade duration
// });

// function fadeIn(element, duration) {
//     var opacity = 0;
//     element.style.opacity = opacity;
//     var last = +new Date();
//     var tick = function() {
//         opacity = +element.style.opacity + (new Date() - last) / duration;
//         element.style.opacity = opacity;
//         last = +new Date();

//         if (+opacity < 1) {
//             (window.requestAnimationFrame && requestAnimationFrame(tick)) || setTimeout(tick, 16);
//         }
//     };
//     tick();
// }



// Add parent nav label inline to dropdown
document.addEventListener('DOMContentLoaded', function() {
    const dropdowns = document.querySelectorAll('.navbar-nav .nav-item.dropdown');

    dropdowns.forEach(function(dropdown) {
        const toggleText = dropdown.querySelector('.nav-link.dropdown-toggle').textContent;
        const dropdownHeader = document.createElement('li');
        dropdownHeader.classList.add('dropdown-header', 'not-clickable');
        dropdownHeader.textContent = toggleText;
        const dropdownMenu = dropdown.querySelector('.dropdown-menu');
        dropdownMenu.insertBefore(dropdownHeader, dropdownMenu.firstChild);
    });
});

// Swap toggler icon
document.addEventListener('DOMContentLoaded', function() {
    var navbarToggler = document.querySelector('.navbar-toggler');
    navbarToggler.addEventListener('click', function() {
        if(this.classList.contains('collapsed')) {
            this.classList.remove('is-open');
        } else {
            this.classList.add('is-open');
        }
    });
});




// Code to fix scroll that was acting crazy

// // Fade mobile menu
// document.addEventListener('DOMContentLoaded', function() {
//     var navbarToggler = document.querySelector('.navbar-toggler');
//     var menu = document.querySelector('.navbar-collapse');
  
//     navbarToggler.addEventListener('click', function() {
//       // Check if the menu is visible
//       if (menu.style.opacity === '1') {
//         menu.style.opacity = 0;
//         setTimeout(function() {
//           menu.style.visibility = 'hidden';
//         }, 500); // Use the same duration as the CSS transition
//       } else {
//         menu.style.visibility = 'visible';
//         setTimeout(function() {
//           menu.style.opacity = 1;
//         }, 10); // This small timeout ensures the visibility change has taken effect
//       }
//     });
//   });

// // Fight collapsing
// document.addEventListener('DOMContentLoaded', function() {
//     var navbarNavDropdown = document.getElementById('navbarNavDropdown');
//     var body = document.body;
//     var navbarToggler = document.querySelector('.navbar-toggler');

//     if (!navbarNavDropdown || !navbarToggler) return;

//     function toggleBodyScroll(isOpen) {
//         if (window.innerWidth <= 992) { // Mobile breakpoint
//             body.style.overflow = isOpen ? 'hidden' : '';
//         } else {
//             body.style.overflow = '';
//         }
//     }

//     navbarNavDropdown.addEventListener('transitionend', function(event) {
//         if (event.propertyName === 'height') {
//             navbarNavDropdown.style.height = null;
//         }
//     });

//     navbarToggler.addEventListener('click', function() {
//         var isOpen = !navbarNavDropdown.classList.contains('show');
//         toggleBodyScroll(isOpen);
//     });

//     // Reset styles on resize to avoid desktop menu issues
//     window.addEventListener('resize', function() {
//         // Timeout ensures we check the condition after the resize has completed
//         setTimeout(function() {
//             if (window.innerWidth > 992) { // Desktop breakpoint
//                 body.style.overflow = ''; // Ensure scrolling is enabled
//                 // Ensure the mobile menu is reset properly for desktop view
//                 navbarNavDropdown.classList.remove('show');
//                 navbarNavDropdown.removeAttribute('style');
//             }
//         }, 100);
//     });
// });

// // Stop scroll when mobile menu is open
// document.addEventListener('DOMContentLoaded', function() {
//     const body = document.body;
//     const html = document.documentElement;
//     const navbarToggler = document.querySelector('.navbar-toggler');
//     const navbarCollapse = document.getElementById('navbarNavDropdown');

//     let scrollY = 0;

//     function toggleScrollLock(isLocked) {
//         if (isLocked) {
//             scrollY = window.scrollY;
//             body.style.position = 'fixed';
//             body.style.top = `-${scrollY}px`;
//             body.style.width = '100%';
//             // Adjust html overflow to maintain scrollbar but prevent scrolling
//             html.style.overflowY = 'scroll';
//         } else {
//             body.style.position = '';
//             body.style.top = '';
//             body.style.width = '';
//             window.scrollTo(0, scrollY);
//             // Reset html overflow to default to re-enable scrolling
//             html.style.overflowY = '';
//         }
//     }

//     navbarToggler.addEventListener('click', function() {
//         setTimeout(() => {
//             const isMenuOpen = navbarCollapse.classList.contains('show');
//             toggleScrollLock(isMenuOpen);
//         }, 10);
//     });

//     window.addEventListener('resize', () => {
//         if (window.innerWidth > 992) {
//             toggleScrollLock(false);
//         } else {
//             const isMenuOpen = navbarCollapse.classList.contains('show');
//             toggleScrollLock(isMenuOpen);
//         }
//     });
// });
